import React, {useEffect,useContext,useRef} from "react";
import { useNavigate  } from 'react-router-dom';
import Context from '../context/context';
import CryptoJS from "react-native-crypto-js";
import queryString from 'query-string';
import ReactGA from 'react-ga4';
import { GTMEvents } from '../_helpers/gtm/gtm';
import helpersFunction from '../_helpers/helpersFunction';
import Auth from '../../userServices/authServices';

export default function AutoLogin() {
	

	let navigate = useNavigate();
	const context = useContext(Context);
    const firstUpdate = useRef(true);

   
    useEffect(() => {
        firstUpdate.current = false;
        Checking()
    },[]); 


  

    function Checking(){
        
        //ReactGA.event({ category: 'User',action: 'Conferma DOI'})
        
		const query = queryString.parse(window.location.search);
		var encrypted = query.token
        encrypted = encrypted.replace(/\~/g, '/');
        encrypted = encrypted.replace(/\*/g, '+');
        //helpersFunction.logToBackend("Conferma DOI",{encrypted:encrypted})
        try{
            if(encrypted){

                let bytes  = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
                let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); 
                console.log("Decripted Data",decryptedData)
                if(decryptedData.token){
                    localStorage.setItem('token', decryptedData.token)
                    localStorage.setItem('trackerId', decryptedData.trackerId)
                    
                    Auth.confirmEmail(decryptedData.trackerId, decryptedData.token,window.location.hostname)
                    .then(res => {
                        console.log("Valuto popup_selezione_canale_notifiche e primo_login",context.flusso.popup_selezione_canale_notifiche, res.primo_login)
                        localStorage.setItem('landedTime', new Date())
                        GTMEvents.lead_doi(decryptedData.trackerId, res.email,window.location.hostname)
                        const protocollo = window.location.protocol
                        const dominio = window.location.host
                        window.location.replace(protocollo+"//"+dominio+"/match")

                    }).catch(err => {
                        
                    })
                }else{
                    helpersFunction.logToBackend("No token su DOI confirm",{decriptedData:decryptedData})
                    navigate('/');
                }
       
            }else{
           
                helpersFunction.logToBackend("Codice non criptato su DOI confirm",{encripted:encrypted})
                context.setModalShowHook(true)
                navigate('/find');
            }
        }catch(err){
            helpersFunction.logToBackend("DOI confirm try catch",{error:err.message})
            navigate('/find');
        }
    }

	
    return (<>
              <div>Confirming...</div>
    </>
    );
}